export const autenticado = () => {
  return localStorage.getItem("token") != null;
};

export const saveReturnUrl = () => {
  const returnUrl = window.location.pathname + window.location.search;
  sessionStorage.setItem("returnURL", returnUrl);
};

export const logout = (redirect?: boolean) => {
  localStorage.clear();
  saveReturnUrl();
  if (redirect) window.location.href = "/login";
};
